import { Table, TableColumnsType } from 'antd';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { getDashboardPortfolios } from '../../api/tutor.api';
import useAxios from '../../hooks/useAxios';
import { getCommonCodeLabel } from '../../lib/store';
import { IGetPortfolios, IPortfolioItem } from '../../models/tutor.model';
import Button from '../Button';
import ShowPortfolioModal from '../class/portfolio/modals/ShowPortfolioModal';
import ErrorResponse from '../ErrorResponse';
import Loader from '../Loader';

interface IProps {
  semesterCode: number | undefined;
}

const PortfolioTable: FC<IProps> = ({ semesterCode }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { data: res, isLoading, error, execute } = useAxios<IGetPortfolios>();

  const [showPortfolioVisible, setShowPortfolioVisible] = useState(false);
  const [item, setItem] = useState<IPortfolioItem>();

  useEffect(() => {
    if (semesterCode) {
      doGetPortfolios();
    }
  }, [semesterCode]);

  const doGetPortfolios = () => {
    if (!semesterCode) return;

    execute(getDashboardPortfolios(semesterCode));
  };

  const columns: TableColumnsType<IPortfolioItem> = [
    {
      title: t('common.column.category'),
      dataIndex: 'learningTypeCode',
      align: 'center',
      render: (value) => getCommonCodeLabel('GR0001', value, 'ko'),
    },
    {
      title: t('class.tutor.column6'),
      dataIndex: 'subjectName',
      align: 'center',
    },
    {
      title: t('common.column.activity'),
      dataIndex: 'activityName',
      align: 'center',
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      align: 'center',
    },
    {
      title: t('common.menu.student'),
      dataIndex: 'studentKorName',
      align: 'center',
    },
    {
      title: t('common.menu.studentEng'),
      dataIndex: 'studentEngName',
      align: 'center',
    },
    {
      title: t('common.column.date1'),
      dataIndex: 'studentRegDate',
      align: 'center',
      render: (value) => moment(value).format('YYYY.MM.DD'),
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div className="comm-bx__between">
        <div className="comm-sch_result"><b>{t('common.text.portfolio')}</b></div>
        <div className="comm-btn__area">
          <Button
            className="btn-basic pink"
            text="More"
            onClick={() => history.push('/class/portfolio')}
          />
        </div>
      </div>
      <div className='comm-table__area'>
        <Table
          columns={columns}
          dataSource={res?.data}
          pagination={{
            current: 1,
            pageSize: 5,
          }}
          onRow={(record) => {
            return {
              onClick: () => {
                setItem(record);
                setShowPortfolioVisible(true);
              },
            };
          }}
          rowClassName="pointer"
        />
      </div>

      {showPortfolioVisible && (
        <ShowPortfolioModal
          visible={showPortfolioVisible}
          setVisible={setShowPortfolioVisible}
          item={item}
          doGetPortfolios={doGetPortfolios}
        />
      )}
    </>
  );
};

export default PortfolioTable;
